module.exports = __webpack_public_path__ + "img/IMG_0169.3faac31f.jpg";